import { IsEnum, IsNotEmpty } from 'class-validator';
import { TokenVaultVerification } from './token-vault-verification.enum';
import { UserActionTokenDto } from './user-action-token.dto';

export class UserActionTokenVerificationDto extends UserActionTokenDto {
  @IsEnum(TokenVaultVerification)
  @IsNotEmpty()
  verification!: TokenVaultVerification;
}
